import {
  UPLOAD_FOLDER_FILES_SUCCESS, UPLOAD_FOLDER_FILES_FAILURE,
  CREATE_FOLDER_FILES_SUCCESS, CREATE_FOLDER_FILES_FAILURE,
  GET_ALL_FOLDER_FILES_SUCCESS, GET_ALL_FOLDER_FILES_FAILURE,
  DELETE_FOLDER_FILES_SUCCESS, DELETE_FOLDER_FILES_FAILURE,
  GET_FOLDER_FILES_SUCCESS, GET_FOLDER_FILES_FAILURE,
  GET_FILES_DOWNLOAD_SUCCESS,
  GET_FILES_DOWNLOAD_FAILURE,
  RESET_FOLDER_FILES
} from "../actions/actionTypes";

const initialState = {
  uploadfolderfiles: JSON.parse(localStorage.getItem("uploadfolderfiles")) || [],
  createfolderfiles: JSON.parse(localStorage.getItem("createfolderfiles")) || [],
  allfolderfiles: JSON.parse(localStorage.getItem("allfolderfiles")) || [],
  // getfiles: JSON.parse(localStorage.getItem("getfiles")) || [],
  deletefolderfiles: JSON.parse(localStorage.getItem("deletefolderfiles")) || null,
  downloadfiles:[],
  getfiles:[],
  error: null,
};



const folderSectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_FOLDER_FILES_SUCCESS:
      // Update local storage with the newly uploaded files
      const updatedFiles = [...state.folderfiles, ...action.payload];
      localStorage.setItem("uploadfolderfiles", JSON.stringify(updatedFiles));

      return {
        ...state,
        uploadfolderfiles: action.payload,
        folderfiles: updatedFiles, // Update the folderfiles state directly
        error: null
      };

    case CREATE_FOLDER_FILES_SUCCESS:
      localStorage.setItem("createfolderfiles", JSON.stringify(action.payload));
      return {
        ...state,
        createfolderfiles: action.payload,
        error: null
      };

    case GET_ALL_FOLDER_FILES_SUCCESS:
      localStorage.setItem("allfolderfiles", JSON.stringify(action.payload));
      return {
        ...state,
        allfolderfiles: Array.isArray(action.payload) ? action.payload : [action.payload],
        error: null
      };

    case GET_FOLDER_FILES_SUCCESS:
      // Update local storage with the latest folder data
      // localStorage.setItem("getfiles", JSON.stringify(action.payload));
      console.log("in rducer",action.payload)
      return { ...state, getfiles: action.payload, error: null };

      
    case GET_FILES_DOWNLOAD_SUCCESS:
      // Update local storage with the latest folder data
      // localStorage.setItem("getfiles", JSON.stringify(action.payload));
      console.log("in rducer",action.payload)
      return { ...state, downloadfiles: action.payload, error: null };

    case DELETE_FOLDER_FILES_SUCCESS:
      const folderId = action.payload.folderId || null;
      localStorage.setItem("deletefolderfiles", folderId ? folderId.toString() : "");

      // Remove the deleted file from the current list
      const remainingFiles = state.folderfiles.filter(
        file => file.id !== action.payload.id
      );
      localStorage.setItem("folderfiles", JSON.stringify(remainingFiles));

      return {
        ...state,
        folderfiles: remainingFiles,
        deletefolderfiles: folderId,
        error: null
      };

      case RESET_FOLDER_FILES:
  return {
    ...state,
    getfiles: [] // ✅ Clear the file list shown in table
  };

    case UPLOAD_FOLDER_FILES_FAILURE:
    case CREATE_FOLDER_FILES_FAILURE:
    case GET_ALL_FOLDER_FILES_FAILURE:
    case GET_FOLDER_FILES_FAILURE:
    case GET_FILES_DOWNLOAD_FAILURE:
    case DELETE_FOLDER_FILES_FAILURE:
      return {
        ...state,
        error: action.payload
      };

    default:
      return state;
  }
};

export default folderSectionReducer;
